import React from 'react';
import { useToolTab } from '../../contexts/ToolTabContext';
import '../../style/tool-tab.css';

function ToolTabToggleBtn() {
  const { panels, isOpen, setOpen } = useToolTab();

  // ToolTabContext는 GIG SPACE 전용이 아니라 페이지-무관 범용 우측 탭이다 —
  // 패널이 등록되어 있으면(GIG든 마이페이지든) 어디서나 토글 버튼을 보여준다.
  if (panels.length === 0) return null;

  const urgentBadge = panels.reduce((sum, p) => sum + (p.badge || 0), 0);

  return (
    <button
      type="button"
      className={`btn-fab btn-fab-accent tool-tab-toggle-btn${isOpen ? ' open' : ''}`}
      onClick={() => setOpen(!isOpen)}
      title={isOpen ? '도구 패널 닫기' : '도구 패널 열기'}
    >
      <span className="material-symbols-rounded btn-fab-icon-rest">more_vert</span>
      <span className="material-symbols-rounded btn-fab-icon-active">
        {isOpen ? 'close' : 'space_dashboard'}
      </span>
      {urgentBadge > 0 && !isOpen && (
        <span className="tool-tab-tab-badge" style={{ position: 'absolute', top: 2, right: 2 }}>
          {urgentBadge}
        </span>
      )}
    </button>
  );
}

export default ToolTabToggleBtn;
